// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ePuuR","icon":"styles_icon__3PUxl"};